import { useEffect } from 'react';

import { IUseScript, useScript } from '../../footer/email-capture/useScript';

import { SailthruClient } from './SailthruClient';

export function useSailthru (): void {
    const { loaded }: IUseScript =  useScript(SailthruClient.API_URL);

    useEffect((): void => {
        if (loaded) {
            SailthruClient.initialize();
        }
    }, [loaded]);
}
